import { render } from "./masteritemp2h.vue?vue&type=template&id=a46deefe"
import script from "./masteritemp2h.vue?vue&type=script&lang=js"
export * from "./masteritemp2h.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__